import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import API, { createAxiosHeaders } from "../utils/api";
import { useSnackbar } from "notistack";
import "./visit.css";
import logo from '../karuncup.svg';
import { getLeagues } from "../services/leaguesService";

const VisitRequestForm = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [leagues, setLeagues] = useState([]);

  const [formData, setFormData] = useState({
    visitor_type: "",
    name: "",
    phone_number: "",
    num_visitors: "",
    league: "",
  });

  // ---------------------------
  //     Load Leagues (DarkPro)
  // ---------------------------
  useEffect(() => {
    getLeagues()
      .then((parents) => {
        const safeParents = parents || [];

        // استخراج لیگ‌های زیرمجموعه فعال (leaf leagues)
        const activeLeafLeagues = safeParents
          .flatMap((p) => p.sub_leagues || [])
          .filter((l) => l.league_type === "active");

        setLeagues(activeLeafLeagues);
      })
      .catch(() => {
        enqueueSnackbar("خطا در دریافت اطلاعات لیگ‌ها!", { variant: "error" });
      });
  }, [enqueueSnackbar]);

  // Handle change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    API.post("/api/visit-requests/", formData, createAxiosHeaders())
      .then(() => {
        enqueueSnackbar("درخواست با موفقیت ثبت شد!", {
          variant: "success",
        });
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          const data = err.response.data;

          // برای هر فیلد خطاها را نمایش بده
          Object.keys(data).forEach((field) => {
            const fieldErrors = data[field];

            if (Array.isArray(fieldErrors)) {
              fieldErrors.forEach((msg) => {
                enqueueSnackbar(msg, { variant: "error" });
              });
            } else {
              enqueueSnackbar(data[field], { variant: "error" });
            }
          });
        } else {
          enqueueSnackbar("خطایی رخ داد.", { variant: "error" });
        }
      });
  };

  return (
    <>
      {/* HEADER */}
      <header className="flex flex-col px-6 md:px-16 py-6 relative z-20">
        <div className="flex items-center justify-between border-b py-4">
       

        <motion.button
          whileHover={{ scale: 1.1 }}
          onClick={() => (window.location.href = "/")}
          className="px-6 py-2 neon-border bg-lime-500 text-black rounded-xl text-base font-semibold hover:bg-lime-300 transition"
        >
          بازگشت
        </motion.button>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center gap-3"
        >
          <img
            src={logo}
            alt="Karun Cup Logo"
            className="h-12 w-12 object-contain "
          />
          
        </motion.div>
        </div>
        
          <h1 className="mt-8 text-xl mx-auto text-center md:text-2xl font-bold neon-text-free-visit">
            صفحه رزور حضور در لیگ های کارون‌کاپ
          </h1>
        
      </header>

      {/* FORM PAGE */}
      <div
        className="h-fit bg-black text-white flex justify-center  p-6 relative overflow-hidden"
        dir="rtl"
      >
        <div className="absolute inset-0 neon-bg"></div>
        {/* <div className="neon-circle"></div> */}

        <motion.form
          onSubmit={handleSubmit}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-lg neon-card p-8 rounded-2xl relative z-10"
        >
          <h1 className="text-center neon-text-free-visit text-lg mb-8 font-bold">
            فرم درخواست بازدید
          </h1>

          {/* Visitor Type */}
          <label className="form-label">نوع بازدید کننده</label>
          <select
            name="visitor_type"
            value={formData.visitor_type}
            onChange={handleChange}
            className="form-input neon-input mb-5"
            required
          >
            <option value="">انتخاب کنید</option>
            <option value="company">شرکتی</option>
            <option value="organization">سازمانی</option>
            <option value="individual">آزاد</option>
          </select>

          {/* Name */}
          <label className="form-label">نام سازمان/شرکت/فرد</label>
          <input
            type="text"
            name="name"
            placeholder="مثلاً شرکت آریان"
            value={formData.name}
            onChange={handleChange}
            className="form-input neon-input mb-5"
            required
          />

          {/* Phone */}
          <label className="form-label">شماره تماس</label>
          <input
            type="text"
            name="phone_number"
            placeholder="مثلاً 09351234567"
            value={formData.phone_number}
            onChange={handleChange}
            className="form-input neon-input mb-5"
            required
          />

          {/* Visitors Count */}
          <label className="form-label">تعداد بازدید کننده</label>
          <input
            type="number"
            name="num_visitors"
            min="1"
            placeholder="تعداد نفرات"
            value={formData.num_visitors}
            onChange={handleChange}
            className="form-input neon-input mb-5"
            required
          />

          {/* League */}
          <label className="form-label">انتخاب لیگ</label>
          <select
            name="league"
            value={formData.league}
            onChange={handleChange}
            className="form-input neon-input mb-5"
            required
          >
            <option value="">یک لیگ انتخاب کنید</option>

            {leagues.length > 0 ? (
              leagues.map((lg) => (
                <option key={lg.id} value={lg.id}>
                  {lg.name}
                  {lg.parent_league ? ` (${lg.parent_league.name})` : ""}
                </option>
              ))
            ) : (
              <option>در حال بارگذاری...</option>
            )}
          </select>

          <motion.button
            whileHover={{ scale: 1.05 }}
            className="neon-btn w-full py-3 text-base font-semibold mt-4"
          >
            ثبت درخواست
          </motion.button>
        </motion.form>
      </div>
    </>
  );
};

export default VisitRequestForm;
